import { create } from 'zustand';

import { ApiScenarioResponse } from '@/shared/api/generated/data-contracts';
import { ApiBaseError, HttpResponse } from '@/shared/api/generated/http-client';

type ScenariosMap = { [scenarioDtoId: string]: ApiScenarioResponse };
type ScenariosStore = {
  scenariosList: ApiScenarioResponse[] | null;
  individualScenariosMap: ScenariosMap;
  promise: Promise<HttpResponse<ApiScenarioResponse[], ApiBaseError>> | null;
  setScenariosList: (scenariosList: ApiScenarioResponse[]) => void;
  setScenario: (scenario: ApiScenarioResponse) => void;
  addScenario: (scenario: ApiScenarioResponse) => void;
  updateScenario: (scenario: ApiScenarioResponse) => void;
  removeScenario: (scenarioDbId: string) => void;
  setPromise: (promise: Promise<HttpResponse<ApiScenarioResponse[], ApiBaseError>> | null) => void;
};

export const useScenariosStore = create<ScenariosStore>((set, get) => ({
  scenariosList: null,
  scenariosMap: null,
  individualScenariosMap: {},
  promise: null,
  setPromise: (promise) => {
    set({ promise });
  },
  setScenariosList: (scenariosList) => {
    set({ scenariosList });
  },
  removeScenario: (scenarioDbId) => {
    const store = get();

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { [scenarioDbId]: _deletedScenario, ...individualScenariosMap } =
      store.individualScenariosMap;

    const scenariosList = store.scenariosList?.filter((scenario) => scenario.id !== scenarioDbId);

    set({ individualScenariosMap, scenariosList });
  },
  addScenario: (scenario) => {
    const store = get();

    const individualScenariosMap = { ...store.individualScenariosMap, [scenario.id]: scenario };
    const scenariosList = store.scenariosList
      ? store.scenariosList.concat(scenario)
      : store.scenariosList;

    set({ individualScenariosMap, scenariosList });
  },
  setScenario: (scenario) => {
    set({ individualScenariosMap: { ...get().individualScenariosMap, [scenario.id]: scenario } });
  },
  updateScenario: (scenario) => {
    const store = get();

    const newScenariosList = structuredClone(store.scenariosList);
    const updatedScenarioIndex = newScenariosList?.findIndex((s) => s.id === scenario.id);

    if (newScenariosList && typeof updatedScenarioIndex === 'number') {
      newScenariosList[updatedScenarioIndex] = scenario;
    }

    set({
      individualScenariosMap: { ...get().individualScenariosMap, [scenario.id]: scenario },
      scenariosList: newScenariosList,
    });
  },
}));
